<script>
	import { createEventDispatcher } from "svelte";

	import Form from "@svelteschool/svelte-forms";
	import TextField from "$lib/fields/TextField.svelte";
	import CountrySelector from "$lib/fields/CountrySelector.svelte";
	import TimeZoneSelector from "$lib/fields/TimeZoneSelector.svelte";

	export let values = {};

	export const validate = () => {
		for (const name in callbacks) {
			callbacks[name]();
		}
	};

	const callbacks = {
		company: null,
		city: null,
	};

	const required = ["company", "city", "country", "timezone"];
	const dispatch = createEventDispatcher();

	$: values &&
		dispatch("validated", {
			form: "company",
			validated: required.every((key) => values[key]?.trim()),
		});
</script>

<Form bind:values>
	<TextField
		label="Company/Sole proprietor/Individual name"
		placeholder="Business name"
		maxlength="40"
		name="company"
		value={values.company ?? ""}
		bind:trigger={callbacks.company}
	/>
	<TextField
		label="Town or City"
		name="city"
		maxlength="50"
		block={false}
		value={values.city ?? ""}
		bind:trigger={callbacks.city}
	/>
	<CountrySelector bind:value={values.country} />
	<TimeZoneSelector bind:value={values.timezone} />
</Form>
